export const types = Object.freeze({
  fetchSalesDetails: 'FETCH-SALES-DETAILS',
  updateGeneralInformation: 'UPDATE-GENERAL-INFORMATION',
  createPartner: 'CREATE-PARTNER',
  updateOnBoardingInformation: 'UPDATE-OBOARDING-INFORMATION',
  updateInvoicingInformation: 'UPDATE-INVOICING-INFORMATION',
});

export const initialState = {
  partnerId: null,
  lastModified: null,
  currentStep: 0,
  generalInformation: {
    firmName: null,
    typeOfOffice: null,
    advisorOriginType: null,
    infineLicenceNumber: null,
  },
  onboardingInformation: {
    firstContactPersonFirstName: null,
    firstContactPersonMiddleName: null,
    firstContactPersonLastName: null,
    firstContactPersonEmail: null,
  },
  invoicingInformation: {
    invoiceStartDate: null,
    typeOfInvoice: null,
    onboardingFeePerMonth: 0,
    onboardingEndDate: null,
    isMinimumFee: true,
    minimumFee: '',
    customAmountPerMonth: 0,
    reductionPercentage: 0,
    reductionEndDate: null,
  },
};

export const salesReducer = (state, action) => {
  switch (action.type) {
    case types.fetchSalesDetails: {
      const {
        generalInformation, onboardingInformation, invoicingInformation, partnerId, currentStep,
      } = action.payload;
      return {
        ...state,
        partnerId,
        currentStep,
        generalInformation,
        onboardingInformation,
        invoicingInformation,
      };
    }
    case types.createPartner: {
      const { partnerId, formValues } = action.payload;
      return {
        ...state,
        partnerId,
        generalInformation: formValues,
      };
    }
    case types.updateGeneralInformation:
      return { ...state, generalInformation: action.payload };
    case types.updateOnBoardingInformation: {
      const { formValues } = action.payload;
      return { ...state, onboardingInformation: formValues };
    }
    case types.updateInvoicingInformation: {
      const { lastModified, formValues } = action.payload;
      return { ...state, lastModified, invoicingInformation: formValues };
    }
    default:
      return state;
  }
};
